import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { FieldDef } from 'app/core/models';
import { ReportLayoutChart } from 'app/modules/reporting/reporting.types';

type ChartSetupModalData = {
  fields: FieldDef[];
  title: string;
  visualization: Partial<ReportLayoutChart>;
  isTimeSeries: boolean;
  allowRelatedObjectFields: boolean;
};

@Component({
  selector: 'app-chart-setup-modal',
  templateUrl: './chart-setup-modal.component.html',
  styleUrls: ['./chart-setup-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartSetupModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ChartSetupModalData,
    private readonly matDialogRef: MatDialogRef<ChartSetupModalComponent>,
  ) {}

  onCloseCreateVisualization(chart: Partial<ReportLayoutChart>): void {
    this.matDialogRef.close(chart);
  }

  close(): void {
    this.matDialogRef.close();
  }
}
